import { store } from '../store';
import {createApp} from 'vue';
import {sendPetition} from './scripts';

if(document.querySelector('.p-checkout-results-module')){
	var app_courses_module = createApp({
		data(){
			return {
				products:[],
				product_type:"",
				paymentMethod: "",
				idFactura: "",
				registrationId: "",
				inscriptionId: "",
				pickupLocation: "",
				errorCode: 0,
				name: "",
				surname: "",
				productName: "",
				purchase_status: "",
				event_url: "#"
			}
		},
		computed: {
			clientLogged(){
				return store.getters['account/clientLogged']
			},
			sessionInfo(){
				return store.getters['account/sessionInfo']
			}
		},
		mounted(){
			console.log('initializing checkout result page');
			let app = this;
			app.name = app.sessionInfo.name;
			app.surname = app.sessionInfo.surname;
			app.paymentMethod = sessionStorage.getItem('paymentMethod');
			app.errorCode = sessionStorage.getItem('errorCode');
			//console.log(app.errorCode)
			let results = app.getJsonFromUrl(location.href);
			app.purchase_status = results['result'];

			//console.log(app.purchase_status);

			app.product_type = sessionStorage.getItem('checkoutProductsType');
			//console.log(app.product_type);
			//sessionStorage.removeItem('checkoutProductsType');
			app.products = JSON.parse(sessionStorage.getItem('checkoutProducts'));
			//console.log(app.products);
			//sessionStorage.removeItem('checkoutProducts');
			if (app.product_type != 'books') {
				app.productName = app.products[0].title;
			}
			app.paymentMethod = sessionStorage.getItem('paymentMethod');
			//sessionStorage.removeItem('paymentMethod');
			if (sessionStorage.getItem('idFactura')) {
				app.idFactura = sessionStorage.getItem('idFactura');
				//console.log(sessionStorage.getItem('idFactura'))
				//sessionStorage.removeItem('idFactura');
			}
			if (sessionStorage.getItem('registrationId')) {
				app.registrationId = sessionStorage.getItem('registrationId');
				//console.log(sessionStorage.getItem('registrationId'))
				//sessionStorage.removeItem('registrationId');
			}
			if (sessionStorage.getItem('inscriptionId')) {
				app.inscriptionId = sessionStorage.getItem('inscriptionId');
				//console.log(sessionStorage.getItem('inscriptionId'))
				//sessionStorage.removeItem('inscriptionId');
			}
			if (sessionStorage.getItem('pickupLocation')) {
				app.pickupLocation = sessionStorage.getItem('pickupLocation');
				//sessionStorage.removeItem('pickupLocation');
			}
			if (app.paymentMethod == "J") {
				switch (app.product_type){
					case 'course':
						if (app.purchase_status == "success") {
							app.confirmCourseRegistration();
						}
						break;
					case 'activity':
						if (app.purchase_status == "success") {
							app.confirmActivityRegistration();
						}
						break;
					case 'books':
						if (app.purchase_status == "success") {
							app.notifyBookSuccess();
						}else if (app.purchase_status == "error") {
							app.notifyBookError();
						}
						break;
					default:
						console.log("ERROR: Product type not supported.");
				}
			}

			this.event_url = this.generateEventOnCalendar();
		},
		methods:{
			confirmCourseRegistration: function(){
				let app = this;
				let url = "/wp-content/themes/cateb/src/services/checkout/coursePaymentConfirmation.php?registrationId="+app.registrationId
				sendPetition(url, (data)=>{
					//console.log(data);
				});
			},
			confirmActivityRegistration: function(){
				let app = this;
				let url = "/wp-content/themes/cateb/src/services/checkout/activityPaymentConfirmation.php?inscriptionId="+app.inscriptionId
				sendPetition(url, (data)=>{
					//console.log(data);
				});
			},
			notifyBookSuccess: function(){
				let app = this;
				let url = "/wp-content/themes/cateb/src/services/checkout/bookPurchaseConfirmed.php?idFactura="+app.idFactura
				sendPetition(url, (data)=>{
					//console.log(data);
				});
			},
			notifyBookError: function(){
				let app = this;
				let url = "/wp-content/themes/cateb/src/services/checkout/bookPurchaseError.php?idFactura="+app.idFactura
				sendPetition(url, (data)=>{
					//console.log(data);
				});
			},
			getJsonFromUrl: function(url) {
				if(!url) url = location.href;
				var question = url.indexOf("?");
				var hash = url.indexOf("#");
				if(hash==-1 && question==-1) return {};
				if(hash==-1) hash = url.length;
				var query = question==-1 || hash==question+1 ? url.substring(hash) :
				url.substring(question+1,hash);
				var result = {};
				query.split("&").forEach(function(part) {
				  if(!part) return;
				  part = part.split("+").join(" "); // replace every + with space, regexp-free version
				  var eq = part.indexOf("=");
				  var key = eq>-1 ? part.substr(0,eq) : part;
				  var val = eq>-1 ? decodeURIComponent(part.substr(eq+1)) : "";
				  var from = key.indexOf("[");
				  if(from==-1) result[decodeURIComponent(key)] = val;
				  else {
					var to = key.indexOf("]",from);
					var index = decodeURIComponent(key.substring(from+1,to));
					key = decodeURIComponent(key.substring(0,from));
					if(!result[key]) result[key] = [];
					if(!index) result[key].push(val);
					else result[key][index] = val;
				  }
				});
				return result;
			},
			generateEventOnCalendar: function(){
				this.product_type;
				if (this.product_type == "course" || this.product_type == "activity") {
					let prod = this.products[0];
					let _title = prod.title.trim();
					let _start_date = prod.startDate;
					let _end_date = prod.endDate;

					/* console.log(_start_date);
					console.log(Date.parse(_start_date))
					console.log(_end_date) */
					let _location = prod.location.trim();

					let _url = "https://calendar.google.com/calendar/event?action=TEMPLATE";

					if (_title !== '') {
						_url = _url + "&text="+ _title ;
					}
					if (_start_date !== '') {
						let isTimeHas = /:/.test(_start_date);
						_start_date = _start_date.split(/-|\s|:/);
						if (isTimeHas){
							_start_date = [
								_start_date[0],
								_start_date[1].toString().padStart(2, '0'),
								_start_date[2].toString().padStart(2, '0'),
								"T",
								(_start_date[3]-1).toString().padStart(2, '0'),
								_start_date[4].toString().padStart(2, '0'),
								_start_date[5].toString().padStart(2, '0')
							];
						}
						_start_date = _start_date.join("");
						let _dates = _start_date + "Z";
						if (_end_date !== '') {
							let isTimeHas = /:/.test(_end_date);
							_end_date = _end_date.split(/-|\s|:/);
							if (isTimeHas){
								_end_date = [
									_end_date[0],
									_end_date[1].toString().padStart(2, '0'),
									_end_date[2].toString().padStart(2, '0'),
									"T",
									(_end_date[3]-1).toString().padStart(2, '0'),
									_end_date[4].toString().padStart(2, '0'),
									_end_date[5].toString().padStart(2, '0')
								];
							}
							_end_date = _end_date.join("");
							_dates = _dates + "/" + _end_date + "Z";
						}

						_url = _url + "&dates="+ _dates ;
					}
					if (_location !== '') {
						_url = _url + "&location="+ _location ;
					}
					_url = encodeURI(_url);
					return _url;
				}
			}
		}
	}).mount(document.querySelector('.p-checkout-results-module'));
}
